import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';

import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import { useWidgetTheme } from '@swf/poker';

import type { CreateModalLocationState, PageData } from '../../types/common';

import styles from './NewUser.scss';
import { NewUserContextProvider } from './NewUserContext';
import NewUserFlow from './NewUserFlow';

interface LocationState extends PageData {
  clubId: number;
  widgetSelect: CreateModalLocationState['widgetSelect'];
  widgetDispatch: CreateModalLocationState['widgetDispatch'];
  widgetId?: string;
}

const NewUser: React.FC = () => {
  const {
    state: { widgetId }
  } = useLocation<LocationState>();
  const { setStyle } = useContext(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.modalContainer,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <NewUserContextProvider>
      <Body className={styles.body}>
        <StarsWizard flow={[NewUserFlow]}>
          <NewUserFlow widgetId={widgetId} />
        </StarsWizard>
      </Body>
    </NewUserContextProvider>
  );
};

export default NewUser;
